import { createStyles, makeStyles, Theme } from '@material-ui/core';

const stylesBase = (theme: Theme) =>
  createStyles({
    root: {
      background: '#ffffff',
      borderRadius: 10,
      padding: 16,
      maxWidth: 370,
      width: '100%',
      zIndex: 1301,
      // border: `1px solid ${theme.palette.button.disabled}`,
      // marginTop: theme.spacing(2),
      boxShadow: '0px 4px 8px rgba(51, 65, 85, 0.15)',
      marginLeft: 16,
      top: 'initial',

      [theme.breakpoints.down('sm')]: {},
    },

    listItem: {
      width: 66,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 66,
      padding: 2,
      margin: '8px 8px 0 0',
      '& svg': {
        padding: 5,
      },
      '&:hover': {
        border: '2px solid #333',
        cursor: 'pointer',
      },
      '& .MuiAvatar-root': {
        width: 60,
        height: 60,
      },
    },

    avtiveListItem: {
      border: '2px solid red',
    },

    profile: {
      padding: '0 15px',
      [theme.breakpoints.between('sm', 'md')]: {
        marginBottom: 7,
      },
    },
    profileSurname: {
      color: theme.palette.logo.main,
    },
    profileName: {},
    logoutButton: {
      borderTopLeftRadius: 0,
      borderTopRightRadius: 0,
      backgroundColor: 'transparent',
    },
    profileButtons: {
      flexDirection: 'column',
    },
    instructionButton: {
      borderBottomLeftRadius: 0,
      borderBottomRightRadius: 0,
    },
    profileButton: {
      backgroundColor: '#fff',
      borderRadius: 10,
      '& .MuiButtonBase-root': {
        width: '100%',
        justifyContent: 'flex-start',
        padding: '11px 20px',
      },

      '&:nth-child(2)': {
        '& .MuiButtonBase-root': {
          '& svg': {
            marginLeft: -2,
          },
        },
      },
      // [theme.breakpoints.between('sm', 'md')]: {
      //   borderTop: `1px solid ${theme.palette.text.disabled}`,
      //   '& .MuiButtonBase-root': {
      //     borderRadius: 0,
      //   },
      // },
    },
    userPopperBtnContent: {
      display: 'flex',
      alignItems: 'center',
    },
  });

export const useStyles = makeStyles(theme => ({
  ...stylesBase(theme),
}));
